import { render } from "./SideButtons.vue?vue&type=template&id=30f02474"
import script from "./SideButtons.vue?vue&type=script&lang=js"
export * from "./SideButtons.vue?vue&type=script&lang=js"

import "./SideButtons.vue?vue&type=style&index=0&id=30f02474&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__